import React from 'react';
import { Link } from 'react-router-dom';
import { getOptimizedImageUrl } from '../lib/cms';
import { getImageAlt } from '../lib/images';

export default function TreatmentCard({ treatment }) {
  const { title, slug_id, short_description, featured_image, hero_image } = treatment;
  const imageSrc = (featured_image && featured_image[0]) || (hero_image && hero_image[0]);
  const linkUrl = `/behandlinger/${slug_id}`;

  return (
    <div className="bg-white border border-taupe-border/80 overflow-hidden flex flex-col h-full shadow-xs">
      <Link to={linkUrl} className="relative h-64 sm:h-72 w-full overflow-hidden bg-sand block group">
        {imageSrc && (
          <img
            src={getOptimizedImageUrl(imageSrc, { width: 700, quality: 85 })}
            alt={getImageAlt(imageSrc, `${title} kropsbehandling hos Cryo by Breum`)}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        )}
      </Link>

      <div className="p-6 sm:p-8 flex flex-col flex-1 justify-between">
        <div>
          <h3 className="font-sans text-xl font-semibold text-espresso uppercase tracking-wider">
            <Link to={linkUrl} className="hover:text-accent-brown transition-colors">
              {title}
            </Link>
          </h3>
          <p className="text-sm text-taupe mt-3 leading-relaxed">
            {short_description}
          </p>
        </div>

        <div className="pt-6 mt-6 border-t border-taupe-border/60 flex items-center justify-between gap-3 flex-nowrap">
          <Link
            to={linkUrl}
            className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-espresso hover:text-accent-brown transition-colors group cursor-pointer whitespace-nowrap"
          >
            <span>Læs mere</span>
            <i className="fa-solid fa-arrow-right text-xs transition-transform group-hover:translate-x-1 shrink-0" aria-hidden="true" />
          </Link>

          <a
            href="https://cryobybreum.planway.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-4 py-2 bg-espresso hover:bg-espresso-light text-white text-xs font-semibold uppercase tracking-wider transition-colors whitespace-nowrap shrink-0"
          >
            <span>Book tid</span>
          </a>
        </div>
      </div>
    </div>
  );
}
